module.exports = "/_next/static/images/d904e5771654b864720428b215c63090-Nubank_HickDuarte_59058 1_md.png.webp";